module.exports = __webpack_public_path__ + "img/39.cbc63b9f.png";